export enum Colors {
  PURPLE = 'purple',
  PURPLE100 = 'purple100',
  PURPLE200 = 'purple200',
  PURPLE300 = 'purple300',
  PURPLE400 = 'purple400',
  PURPLE500 = 'purple500',
  PURPLE600 = 'purple600',
  PURPLE700 = 'purple700',
  PURPLE800 = 'purple800',
  PURPLE900 = 'purple900',
  YELLOW = 'yellow',
  BLUE = 'blue',
  BLUE000 = 'blue000', // equivalente to secondaryBlue in new design system
  BLUE100 = 'blue100', // equivalente to secondaryBlue in new design system
  BLUE200 = 'blue200', // equivalente to secondaryBlue in new design system
  BLUE300 = 'blue300', // equivalente to secondaryBlue in new design system
  BLUE400 = 'blue400', // equivalente to secondaryBlue in new design system
  BLUE500 = 'blue500', // equivalente to secondaryBlue in new design system
  BLUE600 = 'blue600', // equivalente to secondaryBlue in new design system
  BLUE700 = 'blue700', // equivalente to secondaryBlue in new design system
  BLUE800 = 'blue800', // equivalente to secondaryBlue in new design system
  RED = 'red',
  RED000 = 'red000', // equivalente to scoreRedScoredRed in new design system
  RED100 = 'red100', // equivalente to scoreRedScoredRed in new design system
  RED200 = 'red200', // equivalente to scoreRedScoredRed in new design system
  RED300 = 'red300', // equivalente to scoreRedScoredRed in new design system
  RED400 = 'red400', // equivalente to scoreRedScoredRed in new design system
  RED500 = 'red500', // equivalente to scoreRedScoredRed in new design system
  RED600 = 'red600', // equivalente to scoreRedScoredRed in new design system
  RED700 = 'red700', // equivalente to scoreRedScoredRed in new design system
  RED800 = 'red800', // equivalente to scoreRedScoredRed in new design system
  GREEN = 'green',
  PINK = 'pink',
  GREY500 = 'grey500',
  GREY400 = 'grey400',
  GREY300 = 'grey300',
  GREY200 = 'grey200',
  GREY200_2 = 'grey200_2',
  GREY100 = 'grey100',
  WHITE = 'white',
  BLACK = 'black',
  MODAL = 'modal',
  COOL_GREY_100 = 'coolGrey100',
  COOL_GREY_200 = 'coolGrey200',
  COOL_GREY_300 = 'coolGrey300',
  COOL_GREY_400 = 'coolGrey400',
  COOL_GREY_500 = 'coolGrey500',
  COOL_GREY_600 = 'coolGrey600',
  COOL_GREY_700 = 'coolGrey700',
  COOL_GREY_800 = 'coolGrey800',
  COOL_GREY_900 = 'coolGrey900',
  FAIR_GREEN_100 = 'fairGreen100',
  FAIR_GREEN_200 = 'fairGreen200',
  FAIR_GREEN_400 = 'fairGreen400',
  FAIR_GREEN_600 = 'fairGreen600',

  BACKGROUNDS_BACKGROUND = 'backgroundsBackground',
  BACKGROUND_CARD = 'backgroundCard',
  BACKGROUND_PRIMARY_ACTION = 'backgroundPrimaryAction',
  BACKGROUND_SECONDARY_ACTION = 'backgroundSecondaryAction',
  BACKGROUND_ACTIVE = 'backgroundActive',

  BACKGROUNDS_DANGER_SURFACE = 'backgroundDangerSurface',
  BACKGROUNDS_SUCCESS_SURFACE = 'backgroundSuccessSurface',
  BACKGROUNDS_PRIMARY_SURFACE = 'backgroundsPrimarySurface',
  BACKGROUNDS_BETA_SURFACE = 'backgroundsBetaSurface',

  STATES_HOVER_BACKGROUND = 'statesHoverBackground',
  STATES_HOVER_BORDER = 'statesHoverBorder',
  STATES_DISABLED_BACKGROUND = 'statesDisabledBackground',
  STATES_DISABLED_BORDER = 'statesDisabledBorder',
  STATES_FOCUS = 'statesFocus',

  BORDER_BACKGROUND = 'borderBackground',
  BORDER_DEFAULT = 'borderDefault',
  BORDER_PRIMARY = 'borderPrimary',
  BORDER_DANGER = 'borderDanger',
  BORDER_WARNING = 'borderWarning',
  BORDER_SUCCCESS = 'borderSuccess',
  BORDER_BETA = 'borderBeta',

  CONTENT_CONTENT = 'contentContent',
  CONTENT_INVERSE_CONTENT = 'contentInverseContent',
  CONTENT_DISABLED = 'contentDisabled',
  CONTENT_DANGER = 'contentDanger',
  CONTENT_SUCCESS = 'contentSuccess',
  CONTENT_BETA = 'contentBeta',
  CONTENT_MUTED = 'contentMuted',
  CONTENT_PRIMARY = 'contentPrimary',

  BOLD_ACTION_SUCCESS = 'boldActionSuccess',
  BOLD_ACTION_DANGER = 'boldActionDanger',
  BOLD_ACTION_WARNING = 'boldActionWarning',
  BOLD_ACTION_PRIMARY = 'boldActionPrimary',
  BOLD_ACTION_SECONDARY = 'boldActionSecondary',
  BOLD_ACTION_INFO = 'boldActionInfo',

  FRAME_ACTIVE_STATE = 'frameActiveState',
  FRAME_BACKGROUND = 'frameBackground',
}

const charlieColors = {
  [Colors.BACKGROUNDS_BACKGROUND]: '#F7F2ED',
  [Colors.BACKGROUND_PRIMARY_ACTION]: '#111128',
  [Colors.BACKGROUND_SECONDARY_ACTION]: '#E7D9CA',
  [Colors.BACKGROUND_CARD]: '#FCFAF8',
  [Colors.BACKGROUND_ACTIVE]: '#540099',

  [Colors.BACKGROUNDS_DANGER_SURFACE]: '#F3C2BF',
  [Colors.BACKGROUNDS_SUCCESS_SURFACE]: '#C6ECDC',
  [Colors.BACKGROUNDS_PRIMARY_SURFACE]: '#DDB3FF',
  [Colors.BACKGROUNDS_BETA_SURFACE]: '#C2E7F0',

  [Colors.STATES_HOVER_BACKGROUND]: '#7000cc',
  [Colors.STATES_HOVER_BORDER]: '#030317',
  [Colors.STATES_DISABLED_BACKGROUND]: '#A3998F',
  [Colors.STATES_FOCUS]: '#540099',
  [Colors.STATES_DISABLED_BORDER]: '#988C81',

  [Colors.BORDER_BACKGROUND]: '#DFCCB9',
  [Colors.BORDER_DEFAULT]: '#06062D',
  [Colors.BORDER_PRIMARY]: '#A333FF',
  [Colors.BORDER_DANGER]: '#DE5D54',
  [Colors.BORDER_WARNING]: '#EBA147',
  [Colors.BORDER_SUCCCESS]: '#66CCA2',
  [Colors.BORDER_BETA]: '#5BBED7',

  [Colors.CONTENT_CONTENT]: '#06062D',
  [Colors.CONTENT_INVERSE_CONTENT]: '#FCFAF8',
  [Colors.CONTENT_DISABLED]: '#625950',
  [Colors.CONTENT_DANGER]: '#4C0601',
  [Colors.CONTENT_SUCCESS]: '#004D2D',
  [Colors.CONTENT_BETA]: '#003D4D',
  [Colors.CONTENT_MUTED]: '#4D476B',
  [Colors.CONTENT_PRIMARY]: '#2A004D',

  [Colors.BOLD_ACTION_SUCCESS]: '#00CC77',
  [Colors.BOLD_ACTION_DANGER]: '#DA493E',
  [Colors.BOLD_ACTION_WARNING]: '#FFA333',
  [Colors.BOLD_ACTION_PRIMARY]: '#C680FF',
  [Colors.BOLD_ACTION_SECONDARY]: '#E7D9CA',
  [Colors.BOLD_ACTION_INFO]: '#33D6FF',

  [Colors.FRAME_ACTIVE_STATE]: '#0B0B0F',
  [Colors.FRAME_BACKGROUND]: '#2B2B3B',
}

export const baseColors: Record<Colors, string> = {
  ...charlieColors,
  [Colors.PURPLE]: '#5347D1',
  [Colors.PURPLE100]: '#F7F6FE',
  [Colors.PURPLE200]: '#EBE9FB',
  [Colors.PURPLE300]: '#D4D1F5',
  [Colors.PURPLE400]: '#BCB8EA',
  [Colors.PURPLE500]: '#8881DA',
  [Colors.PURPLE600]: '#6057C7',
  [Colors.PURPLE700]: '#483EB1',

  [Colors.PURPLE800]: '#2E2877',
  [Colors.PURPLE900]: '#1E1A4D',

  [Colors.YELLOW]: charlieColors[Colors.BOLD_ACTION_WARNING],
  [Colors.BLUE]: '#43c4eb',
  [Colors.BLUE000]: '#E9F9FF',
  [Colors.BLUE100]: '#C7EFFC',
  [Colors.BLUE200]: '#8DDAF3',
  [Colors.BLUE300]: '#44BEE1',
  [Colors.BLUE400]: '#119DC0',
  [Colors.BLUE500]: '#0A6681',
  [Colors.BLUE600]: '#094D63',
  [Colors.BLUE700]: '#083446',
  [Colors.BLUE800]: '#041E2A',

  [Colors.RED]: '#f26956',
  [Colors.RED000]: '#FFF4F4',
  [Colors.RED100]: charlieColors[Colors.BACKGROUNDS_DANGER_SURFACE],
  [Colors.RED200]: '#FAC1BE',
  [Colors.RED300]: '#F69790',
  [Colors.RED400]: charlieColors[Colors.BOLD_ACTION_DANGER],
  [Colors.RED500]: '#B3291B',
  [Colors.RED600]: charlieColors[Colors.CONTENT_DANGER],
  [Colors.RED700]: '#640D02',
  [Colors.RED800]: '#3E0400',

  [Colors.GREEN]: charlieColors[Colors.BOLD_ACTION_SUCCESS],
  [Colors.PINK]: '#ff6584',

  [Colors.GREY500]: '#0a1b40',
  [Colors.GREY400]: '#4c5766',
  [Colors.GREY300]: '#98a3b3',
  [Colors.GREY200]: '#c4cbd4',
  [Colors.GREY200_2]: '#CFD6E2',
  [Colors.GREY100]: charlieColors[Colors.BACKGROUNDS_BACKGROUND],

  [Colors.WHITE]: charlieColors[Colors.BACKGROUND_CARD],
  [Colors.BLACK]: charlieColors[Colors.CONTENT_CONTENT],

  [Colors.MODAL]: '#FFE5D6',

  [Colors.COOL_GREY_100]: '#F8F9FC',
  [Colors.COOL_GREY_200]: '#F4F6FA',
  [Colors.COOL_GREY_300]: '#E0E4EB',
  [Colors.COOL_GREY_400]: '#B6BCC9',
  [Colors.COOL_GREY_500]: '#838995',
  [Colors.COOL_GREY_600]: '#5E636E',
  [Colors.COOL_GREY_700]: '#454A54',
  [Colors.COOL_GREY_800]: '#29303D',
  [Colors.COOL_GREY_900]: '#151C28',

  [Colors.FAIR_GREEN_100]: charlieColors[Colors.BACKGROUNDS_SUCCESS_SURFACE],
  [Colors.FAIR_GREEN_200]: '#92E0A7',
  [Colors.FAIR_GREEN_400]: '#3FA366',
  [Colors.FAIR_GREEN_600]: charlieColors[Colors.BACKGROUNDS_PRIMARY_SURFACE],
}
